<!-- =========================================================================================
  File Name: ServerMonitoringEmilaSidebar.vue
  Description: Add email , Update email, Delete email - Sidebar component
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t("ADD_EMAIL") : $t("UPDATE_EMAIL") }} </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">
        <template>
          <!-- TITLE -->
          <vs-input  :label="$t('MAIL_TITLE')" key="mail-title" v-model="mailTitle" class="w-full" name="mailTitle" v-validate="{ max:30, required: true }" maxlength="51" />
          <span class="text-danger text-sm" v-show="errors.has('mailTitle')">{{ errors.first('mailTitle') }}</span>
          <br/>

          <!-- TARGET -->
          <div class="mb-5">
            <small>{{$t("SEND_TARGET")}}</small>
            <div>
              <vs-radio v-model="sendTarget" vs-value="1" class="mr-4" vs-name="navbar-type-static">{{this.$t('ALL_MEMBER')}}</vs-radio><br />
              <vs-radio v-model="sendTarget" vs-value="2" vs-name="navbar-type-sticky" class="mr-4">{{this.$t('MEMBER')}}</vs-radio><br />
              <vs-radio v-model="sendTarget" vs-value="3" vs-name="navbar-type-floating">{{this.$t('NONMEMBER')}}</vs-radio>
            </div>
          </div>

          <!-- DATE -->
          <div class="mb-5">
            <small>{{$t("SCHEDULED_DATE")}}</small>
            <DatePicker 
              lang="en" 
              type="date" 
              v-model="sendScheduledDate"
              width="200" 
              format="YYYY-MM-DD"
              :popupStyle="{'z-index': 53002}"
              :disabled-date="notBeforeToday"
              class="w-full"></DatePicker>
            <p class="text-danger text-sm" v-show="checkScheduledDate != ''">{{ checkScheduledDate }}</p>
            <p class="text-danger text-sm" v-show="utcTime!=''">{{ 'UTC+0 : '+  utcTime}}</p> 
            <p class="text-primary text-sm" v-show="seoulTime!=''">{{ 'SEOUL :'+ seoulTime }}</p>
            <p class="text-primary text-sm" v-show="laTime!=''">{{ 'LA :'+ laTime }}</p>  
            <p class="text-primary text-sm" v-show="nyTime!=''">{{ 'New York  : '+ nyTime }}</p>
          </div>

          <!-- BODY -->
          <small>{{$t("MAIL_BODY")}}</small>
          <vs-textarea id="mail-body" v-model="mailBody" :counter-danger.sync="counterDanger" counter="300"  name="mailBody"  v-validate="{ max:300, required: true }" />
           <span class="text-danger text-sm" v-show="errors.has('mailBody')">{{ errors.first('mailBody') }}</span>
        </template>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-5" @click="checkSubmit('Submit')" :disabled="!isFormValid">{{$t('SUBMIT')}}</vs-button>
      <vs-button class="mr-5" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('CLOSE')}}</vs-button>
      <vs-button v-if="this.seq" color="danger" @click="confirmCancel">{{$t('CANCEL_SEND')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
let sanitizeHtml = require('sanitize-html');

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  components: {
    quillEditor,
    VuePerfectScrollbar,
    DatePicker
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  mounted() {
    this.sendScheduledDate = new Date(this.tomorrow.getFullYear(), this.tomorrow.getMonth(), this.tomorrow.getDate(),23,0,0,0)
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        let { seq, mailTitle, mailBody, sendScheduledDate, sendTarget } = JSON.parse(JSON.stringify(this.data))
        this.seq = seq
        this.mailTitle = mailTitle
        this.mailBody = mailBody
        this.sendTarget = sendTarget
        this.sendScheduledDate = new Date(this.$moment(sendScheduledDate,'YYYYMMDDHHmmss').valueOf())
        this.$validator.reset()
      }
    },
    sendScheduledDate(val) {
      if(val === null || val === '' || typeof val === undefined ){
        this.checkScheduledDate = 'The scheduledDate field is required'
        this.utcTime = ''
        this.seoulTime = ''
        this.laTime =''
        this.nyTime = ''
      } else {
        this.checkScheduledDate = ''
        val = new Date(val.setHours(23))
        this.utcTime = this.$moment(this.sendScheduledDate).format('YYYY-MM-DD HH:mm:ss')
        this.seoulTime = this.$moment(this.sendScheduledDate).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss')
        this.laTime = this.$moment(this.sendScheduledDate).tz('America/Los_Angeles').format('YYYY-MM-DD HH:mm:ss')
        this.nyTime = this.$moment(this.sendScheduledDate).tz('America/New_York').format('YYYY-MM-DD HH:mm:ss')
      }
    }
  },
  data() {
    return {
      seq:'',
      sendTarget: 1,
      mailTitle: '',
      mailBody: '',
      counterDanger:false,
      tomorrow : new Date(new Date().setDate(new Date().getDate()+1)),
      sendScheduledDate : '',
      checkScheduledDate: '',
      utcTime: '',
      laTime: '',
      seoulTime: '',
      nyTime:'',
      scheduledDate: '',

      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
        return !this.errors.any() && this.mailTitle != '' && this.mailBody != '' && this.checkScheduledDate == ''
    },
  },
  methods: {
    initValues() {
        if(this.data.seq) return
        this.sendTarget = 1
        this.seq = ''
        this.mailTitle = ''
        this.mailBody = ''
        this.sendScheduledDate = new Date(this.tomorrow.getFullYear(), this.tomorrow.getMonth(), this.tomorrow.getDate(),23,0,0,0)
        this.utcTime = ''
        this.seoulTime = ''
        this.laTime =''
        this.nyTime = ''
    },
    checkSendTime(){
      let scheduledDate = this.$moment(this.sendScheduledDate,'YYYYMMDDHHmmss').tz("Etc/UTC").format('x').valueOf()
      let now = this.$moment(new Date()).tz("Etc/UTC").format('x').valueOf()
      let scheduledDate1Hbefore = scheduledDate - 3600000

      if(now >= scheduledDate1Hbefore){
        return false;
      }else{
        return true;
      }
    },
    async checkSubmit(action){
      this.$vs.loading()

      let checkSend = this.checkSendTime()

      this.$validator.validateAll().then(result => {
        if (result) {
          if(checkSend){
            this.openConfirm(action)
          }else{
            this.$vs.loading.close()
            this.errorAlert(this.$t("ERROR"), this.$t('REFUSE_EDIT_BEFORE_1H'))
          }
        }
      })
      .catch((error)=>{
          this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    openConfirm(action) {
      this.$vs.loading.close()

      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('CONFIRM'),
          text: this.$t('CONFIRM_RESERVE_SEND'),
          accept: this.sendMail,
          acceptText: this.$t('CONFIRM'),
          cancelText: this.$t('CANCEL')
      })
    },
    sendMail() {
      this.$vs.loading()

      let checkSend = this.checkSendTime()

      if(!checkSend){
        this.$vs.loading.close()
        this.errorAlert(this.$t("ERROR"), this.$t('REFUSE_EDIT_BEFORE_1H'))
      }else{
        
        const obj = {
          seq: this.seq,
          sendScheduledDate : this.$moment(this.sendScheduledDate).format('YYYYMMDDHHmmss'),
          sendTarget : this.sendTarget,
          mailTitle :  this.XSSCheck(sanitizeHtml(this.mailTitle),1),
          mailBody : this.XSSCheck(sanitizeHtml(this.mailBody),1),
        }

        if(!this.seq){
          this.$store.dispatch("dataSystem/addNotiEmail", obj)              
          .then(() => {
            this.formClear(this.$t("ADD_NOTIEMAIL_SUCCESS"))
          })
          .catch(error => {
            this.$vs.loading.close()
            this.errorAlert(this.$t("FAIL"), error)
          })
        }else{
          this.$store.dispatch("dataSystem/updateNotiEmail", obj)              
          .then(() => {
            this.formClear(this.$t("UPDATE_NOTIEMAIL_SUCCESS"))
          })
          .catch(error => {
            this.$vs.loading.close()
            this.errorAlert(this.$t("FAIL"), error)
          })
        }
      }
    },
    formClear(submitMessage){
        this.$vs.loading.close()
        this.$emit('closeSidebar')
        this.initValues() 
        this.successAlert(this.$t("SUCCESS"),submitMessage)
         this.$parent.$refs.notiEmailTable.getData()
    },
    notBeforeToday(date) {
      return date <= new Date(new Date().setHours(0, 0, 0, 0));
    },
    confirmCancel(){

      let checkSend = this.checkSendTime()

      if(!checkSend){
         this.errorAlert(this.$t("ERROR"), this.$t('REFUSE_CANCEL_BEFORE_1H'))
      }else{
        this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: this.$t('CONFIRM'),
            text: this.$t('CONFIRM_CANCEL_MAIL'),
            accept: this.cancelMail,
            acceptText: this.$t('CONFIRM'),
            cancelText: this.$t('CANCEL')
        })
      }

    },
    cancelMail(){
      this.$vs.loading()

      let checkSend = this.checkSendTime()

      if(!checkSend){
        this.$vs.loading.close()
        this.errorAlert(this.$t("ERROR"), this.$t('REFUSE_CANCEL_BEFORE_1H'))
      }else{
        if(this.seq){
          this.$store.dispatch("dataSystem/cancleNotiEmail", this.seq)              
          .then(() => {
           this.formClear(this.$t("CANCLE_NOTIEMAIL_SUCCESS"))
          })
          .catch(error => {
            this.$vs.loading.close()
            this.errorAlert(this.$t("FAIL"), error)
          })
        }else{
          this.$vs.loading.close()
          this.errorAlert(this.$t("FAIL"), this.$t('REFUSE_CANCEL_MAIL'))
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52004;
  }

  ::v-deep .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}


</style>

<style lang="scss">
#mail-body{
  height: 180px !important;
}
</style>

